import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import "./QuestionBank.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import questionBankData from "../data/questionBankData";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const QuestionBank = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  const [studentInfo, setStudentInfo] = useState(null);
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  const [checkingAuth, setCheckingAuth] = useState(true);

  const BASE_URL = `${baseAPIUrl}assets/question_bank/school_wise`;
  const QB_BASE = `${baseAPIUrl}assets/question_bank`;
  const AEP_QB_BASE = `${baseAPIUrl}assets/question_bank/aep_question_paper`;

  const [activeTab, setActiveTab] = useState("qb-school");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const checkMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobileDevice(checkMobile);
  }, []);


  const openPdfModal = (className, subject, pdf) => {
    setModalTitle(`${className} - Question bank of ${subject}`);
    if (!pdf || pdf.trim() === "") {
      setPdfUrl("");
    } else {
      setPdfUrl(pdf);
    }
    setShowModal(true);
  };


  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {

    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${baseAPIUrl}admin/general_settings/get_study_mat_user_info`,
          { withCredentials: true }
        );

        if (res.data.status === 1) {
          setStudentInfo(res.data.data);
        } else {
          navigate("/question-bank-login");
        }

      } catch (error) {
        navigate("/question-bank-login");
      } finally {
        setCheckingAuth(false);
      }
    };

    fetchUser();

  }, []);

  const handleLogout = async () => {

    try {
      await axios.get(
        `${baseAPIUrl}admin/general_settings/study_mat_logout`,
        { withCredentials: true }
      );

      navigate("/question-bank-login");

    } catch (error) {
      console.error("Logout failed");
    }
  };

  if (checkingAuth) {
    return (
      <div className="text-center mt-5">
        Loading...
      </div>
    );
  }

  return (
    <div className="academics-page my-4">
      <div className="container my-4">
        {/* ================= HEADER ================= */}
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h5 style={{ color: "#1D293D", fontFamily: 'Lora' }}>
            Name: <strong>{studentInfo?.student_name}</strong><br /><br/>
            School: <strong>{studentInfo?.school_name}</strong>
          </h5>

          <button className="qb-school-wise-logout" onClick={handleLogout}>Log Out</button>
        </div>

        {/* ================= TABS ================= */}
        <div className="qb-school-wise-header">
          <div className="qb-school-wise-nav">

            <button
              className={`qb-school-wise-btn ${activeTab === "qb-school" ? "active" : "outline"
                }`}
              onClick={() => setActiveTab("qb-school")}
            >
              School Wise
            </button>

            <button
              className={`qb-school-wise-btn ${activeTab === "qb-aep" ? "active" : "outline"
                }`}
              onClick={() => setActiveTab("qb-aep")}
            >
              AEP
            </button>

            <button
              className={`qb-school-wise-btn ${activeTab === "qb-bank" ? "active" : "outline"
                }`}
              onClick={() => setActiveTab("qb-bank")}
            >
              Question Bank
            </button>

          </div>
        </div>

        {/* ================= SCHOOL WISE ================= */}
        {activeTab === "qb-school" && (
          <div className="qb-school-wise-tab active">

            <div className="qb-school-wise-cards">

              {Object.entries(questionBankData.schoolWise).map(([slug, school]) => (
                <div key={slug} className="qb-school-wise-card">

                  <h3 style={{ fontFamily: 'Lora' }}>{school.schoolName}</h3>

                  <ul>
                    {Object.entries(school.classes).map(([className, subjects]) => {
                      const collapseId = `${slug}-${className}`.replace(/\s/g, "-");

                      return (
                        <li key={className}>
                          <a data-bs-toggle="collapse" href={`#${collapseId}`} style={{ fontFamily: 'Lora' }}>
                            {className}
                            <i className="bi bi-chevron-down qb-school-wise-arrow"></i>
                          </a>

                          <ul className="collapse" id={collapseId}>
                            {subjects.map((item, index) => (
                              <li
                                key={index}
                                style={{ cursor: "pointer", fontFamily: 'Metropolis-Regular' }}
                                onClick={() =>
                                  openPdfModal(
                                    className,
                                    item.subject,
                                    `${BASE_URL}/${slug}/${className.toLowerCase().replace(" ", "-")}/${item.file}`
                                  )
                                }
                              >
                                <span style={{ color: "#1D293D", fontSize: "15px" }}>
                                  &#10148;
                                </span>{" "}
                                {item.subject}
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>

                </div>
              ))}


            </div>
          </div>
        )}

        {/* ================= AEP ================= */}
        {activeTab === "qb-aep" && (
          <div className="qb-school-wise-tab active text-center">
            <div className="qb-aep-wrapper">
              {Object.entries(questionBankData.aep).map(([className, subjects]) => (
                <div className="qb-aep-card">
                  <h3 style={{ fontFamily: 'Lora', fontSize: '20px', color: '#333', paddingBottom: '10px' }}>{className}</h3>

                  <ul className="qb-aep-list">
                    {subjects.map((item, index) => (
                      <li
                        key={index}
                        className="qb-aep-item"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          openPdfModal(
                            className,
                            item.subject,
                            `${QB_BASE}/${item.file}`
                          )
                        }
                      >
                        <span className="qb-aep-arrow">&#10148;</span>
                        <span className="qb-aep-link">
                          Question bank of - {item.subject}
                        </span>
                      </li>
                    ))
                    }
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ================= QUESTION BANK ================= */}
        {activeTab === "qb-bank" && (
          <div className="qb-school-wise-tab active text-center">

            <div className="qb-aep-wrapper">
              {Object.entries(questionBankData.aepQuestionPaper).map(([className, papers]) => (
                <div className="qb-aep-card">
                  <h3 style={{ fontFamily: 'Lora', fontSize: '20px', color: '#333', paddingBottom: '10px' }}>{className}</h3>

                  <ul className="qb-aep-list">
                    {papers.map((item, index) => (
                      <li
                        key={index}
                        className="qb-aep-item"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          openPdfModal(
                            className,
                            item.title,
                            `${AEP_QB_BASE}/${item.file}`
                          )
                        }
                      >
                        <span className="qb-aep-arrow">&#10148;</span>
                        <span className="qb-aep-link">
                          {item.title}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ✅ ADD MODAL HERE */}
      {showModal && (
        <div className="custom-modal-overlay">

          <div className="custom-modal">

            <div className="custom-modal-header">
              <h5>{modalTitle}</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
              ></button>
            </div>

            <div className="custom-modal-body">

              {!pdfUrl ? (
                <div className="text-center text-danger fw-bold p-3">
                  Content not uploaded. Please wait.
                </div>
              ) : isMobileDevice ? (
                <div className="text-center p-3">
                  <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Open PDF
                  </a>
                </div>
              ) : (
                <iframe
                  src={`${pdfUrl}#toolbar=0`}
                  title="PDF Viewer"
                  className="custom-pdf-frame"
                />
              )}

            </div>

            <div className="custom-modal-footer">
              <button
                className="btn btn-danger"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>

          </div>

        </div>
      )}

    </div>


  );
};





export default QuestionBank;
